import { type BuiltInDispatchEntry, type EVENT_TYPES } from '@care-portals/api-interfaces';
import { TmcBuiltInDispatch } from './tmc.config';
import { VsdigitalBuiltInDispatch } from './vsdigital.config';
import { AutoPilotRxBuiltInDispatch } from './autopilotrx.config';
import { MdiBuiltInDispatch } from './mdi.config';

export { TmcBuiltInDispatch } from './tmc.config';
export { VsdigitalBuiltInDispatch } from './vsdigital.config';
export { AutoPilotRxBuiltInDispatch } from './autopilotrx.config';
export { MdiBuiltInDispatch } from './mdi.config';

const ALL_BUILT_IN_DISPATCH_ENTRIES: BuiltInDispatchEntry[] = [
  // Merge a new integration's file in here the same way `Adapters` merges `adapter-config/*`.
  ...TmcBuiltInDispatch,
  ...VsdigitalBuiltInDispatch,
  ...AutoPilotRxBuiltInDispatch,
  ...MdiBuiltInDispatch
];

/**
 * Every {@link BuiltInDispatchEntry}, keyed by the trigger event that fires it. Generic across
 * integrations (see docs/builtin-dispatch.md) — TMC is the first entry, not the whole scope.
 */
export const BUILT_IN_DISPATCH_CONFIG: Partial<Record<EVENT_TYPES, BuiltInDispatchEntry[]>> =
  ALL_BUILT_IN_DISPATCH_ENTRIES.reduce(
    (byEvent, entry) => {
      (byEvent[entry.triggerEvent] ??= []).push(entry);
      return byEvent;
    },
    {} as Partial<Record<EVENT_TYPES, BuiltInDispatchEntry[]>>
  );

/** Looks up one entry by its stable id — used by rerun() to re-resolve fresh config, not a frozen snapshot. */
export function findBuiltInDispatchEntry(id: string | undefined): BuiltInDispatchEntry | undefined {
  if (!id) return undefined;
  return ALL_BUILT_IN_DISPATCH_ENTRIES.find(entry => entry.id === id);
}
